module.exports = __webpack_public_path__ + "static/media/conheca-shellbox.7f96758f.png";